import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import PaginatedTable from "../../sharedComponents/tableWithPagination";
import AddOrUpdateAd from "./addOrUpdateAd";
import ConfirmDelete from "../../sharedComponents/confirmDelete";
import "./adManagement.scss";
import Tooltip from "../../sharedComponents/tooltip";
import PlaceholderImage from "../../sharedComponents/placeholderImage";

export default function AdListing({ adsList, getAdsList, submitAd, deleteAd }) {
	const [show, setShow] = useState(false);
	const [initialValues, setInitialValues] = useState({});
	const [adId, setAdId] = useState(null);
	const [deleteItem, setDeleteItem] = useState(null);
	const [formType, setFormType] = useState(null);
	const [fileType, setFileType] = useState(null);

	const onUpdateButtonClick = (selectedAdDetails) => {
		setFormType("Update");
		setAdId(selectedAdDetails.id);
		if (selectedAdDetails.video !== null) {
			setInitialValues({
				title: selectedAdDetails.title,
				url: selectedAdDetails.video
			});
			setFileType("video");
		} else {
			setInitialValues({
				title: selectedAdDetails.title,
				url: selectedAdDetails.image,
				link: selectedAdDetails.url
			});
			setFileType("image");
		}
		setShow(true);
	};

	const onToggleButtonClick = (selectedAdDetails) => {
		submitAd(
			"Update",
			selectedAdDetails.video ? "video" : "image",
			{ is_active: !selectedAdDetails.is_active },
			selectedAdDetails.id
		);
	};

	useEffect(() => {
		handleClose();
	}, [adsList]);

	const confirmDelete = (original) => {
		setDeleteItem(original);
	};

	const confirmEvent = (yes) => {
		yes ? deleteAd(deleteItem) : setDeleteItem(null);
	};

	const handleClose = () => {
		setShow(false);
	};

	const onClickAddButton = () => {
		setShow(true);
		setFormType("Add");
		setFileType(null);
		setInitialValues(null);
	};

	const onClickAdType = (string) => {
		setFileType(string);
	};

	const columns = [
		{
			Header: "Thumbnail",
			accessor: "thumbnail",
			width: 130,
			Cell: ({ original: item }) => {
				const itemType = item.video === null ? "image" : "video";
				let image;
				if (itemType === "video") {
					image = item.youtube_id ? `https://img.youtube.com/vi/${item.youtube_id}/1.jpg` : null;
				} else {
					image = item.image;
				}
				return (
					<PlaceholderImage
						src={image}
						width={50}
						height={50}
						bg="rgba(0,0,0,0.1)"
						color="rgba(0,0,0,0.3)"
						objectFit="cover"
					/>
				);
			}
		},
		{
			Header: "Title",
			accessor: "title"
		},
		{
			Header: "Link",
			accessor: "link",
			Cell: (props) => <span>{props.original.image !== null ? props.original.url : null}</span>
		},
		{
			Header: "ACTIONS",
			accessor: "fat_mass",
			width: 120,
			headerClassName: "text-right",
			className: "text-right",
			Cell: ({ original }) => {
				return (
					<div>
						{original.is_active ? (
							<Tooltip content="Disable" placement="left">
								<button
									className="btn btn-primary-dark btn-ghost btn-cell btn-sm mr-2"
									onClick={() => onToggleButtonClick(original)}>
									<i className={`icon icon-not-allowed`} />
								</button>
							</Tooltip>
						) : (
							<Tooltip content="Enable" placement="left">
								<button
									className="btn btn-primary btn-ghost btn-cell btn-sm mr-2"
									onClick={() => onToggleButtonClick(original)}>
									<i className={`icon icon-eye`} />
								</button>
							</Tooltip>
						)}
						<Tooltip content="Edit" placement="left">
							<button
								className="btn btn-success btn-ghost btn-cell btn-sm mr-2"
								onClick={() => onUpdateButtonClick(original)}>
								<i className="icon icon-edit" />
							</button>
						</Tooltip>
						<Tooltip content="Delete" placement="left">
							<button
								className="btn btn-danger btn-ghost btn-cell btn-sm"
								onClick={() => confirmDelete(original)}>
								<i className="icon icon-trash" />
							</button>
						</Tooltip>
					</div>
				);
			}
		}
	];

	return (
		<section className="page page-ad-management">
			<Container>
				<div className="d-flex w-100 align-items-center mb-3">
					<h3 className="flex-fill m-0">Advertisement Management</h3>
					<div className="text-right">
						<div className="btn ml-3 btn-primary pointer" onClick={() => onClickAddButton()}>
							<i className="icon icon-plus"></i> Add new
						</div>
					</div>
				</div>
				<Row>
					<Col>
						<PaginatedTable
							data={adsList && adsList.results}
							columns={columns}
							totalItems={adsList && adsList.count}
							prev={adsList && adsList.previous}
							next={adsList && adsList.next}
							pageSize={20}
							onPagination={(e) => {
								getAdsList(`?limit=20&${e}`);
							}}
						/>
					</Col>
				</Row>
				<AddOrUpdateAd
					show={show}
					handleClose={handleClose}
					formType={formType}
					fileType={fileType}
					onClickAdType={onClickAdType}
					initialValues={initialValues}
					submitAd={submitAd}
					adId={adId}
				/>
				<ConfirmDelete item={deleteItem} message={<div>Are you sure you want to delete?</div>} onEvent={confirmEvent} />
			</Container>
		</section>
	);
}
